@for (language of languages; track language) {
  <button [class.selected]="language === languageService.language()" class="reset" (click)="changeLanguage(language)">
    {{ language | uppercase }}
  </button>
}
